import { render, staticRenderFns } from "./ServiceElement.vue?vue&type=template&id=7d505271&scoped=true&"
import script from "./ServiceElement.vue?vue&type=script&lang=js&"
export * from "./ServiceElement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceElement.vue?vue&type=style&index=0&id=7d505271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d505271",
  null
  
)

export default component.exports